import style from "./invite-buttons-topbar.module.css";
import InviteToBoardButton from "./invite-to-board-button";

const shareButtonStyle = {
  minWidth: "72.78px",
  height: "30px",
  paddingLeft: 0,
  paddingRight: 0,
  justifyContent: "center",
  fontSize: "14px",
  fontWeight: 400,
  fontFamily: "Poppins",
  borderRadius: 6,
  marginRight: "4px",
};

export default function InviteButtonsTopBar({ onInviteClick }: { onInviteClick?: (title?: string) => void }) {
  return (
    <div className={style.container} data-testid="shareButton">
      <InviteToBoardButton customStyle={shareButtonStyle} onInviteClick={onInviteClick} />
    </div>
  );
}
